import { render, staticRenderFns } from "./crud_salary_grades.vue?vue&type=template&id=cdc8afc0&scoped=true"
import script from "./crud_salary_grades.vue?vue&type=script&lang=js"
export * from "./crud_salary_grades.vue?vue&type=script&lang=js"
import style0 from "./crud_salary_grades.vue?vue&type=style&index=0&id=cdc8afc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc8afc0",
  null
  
)

export default component.exports